import MarketingMaterials from './MarketingMaterials';

export default MarketingMaterials;
